import Icon from '@material-ui/icons/Event';

import Create from './Create';
import Edit from './Edit';
import List from './List';
import Show from './Show';

export default {
  name: 'calendar',
  icon: Icon,
  list: List,
  show: Show,
  create: Create,
  edit: Edit,
};
